import { Icon } from '../../ui/Icon';
import { missingLabel } from './lib.js';

export function Checklist({ items, label }: { items: { key: string; label: string; done: boolean }[]; label: string }) {
  return (
    <ul className="ad-checklist" aria-label={label}>
      {items.map((it) => (
        <li key={it.key} className={it.done ? 'done' : undefined}>
          <span className="box" aria-hidden="true">
            {it.done ? <Icon name="check" size="sm" /> : null}
          </span>
          <span className="sr-only">{it.done ? 'Done: ' : 'To do: '}</span>
          <span>{it.label}</span>
        </li>
      ))}
    </ul>
  );
}

/** A 409 not_ready said plainly: what's missing, as a to-do list. */
export function NotReadyPanel({ headline, missing, onEdit, onClose }: { headline: string; missing: string[]; onEdit?: () => void; onClose: () => void }) {
  const items = (missing.length ? missing : ['Something the ad needs is missing. Open it and check every field.']).map((m, i) => ({ key: `${i}-${m}`, label: missingLabel(m), done: false }));
  return (
    <div className="ad-notready" role="alert">
      <b className="t-label">"{headline}" can't go live yet</b>
      <span className="t-caption muted">Finish these, then press Go live again:</span>
      <Checklist items={items} label="What's missing" />
      <div className="row wrap">
        {onEdit ? (
          <button type="button" className="btn btn-primary" onClick={onEdit}>
            Fix it
          </button>
        ) : null}
        <button type="button" className="btn btn-quiet" onClick={onClose}>
          Dismiss
        </button>
      </div>
    </div>
  );
}
